import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  &.", " {\n    ", ";\n  }\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", " {\n    ", "\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { color } from '@scp/ui-shared/theme/variables';
import { LinkOrButton } from '@scp/ui-shared/components/buttons';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { IconWithBadge } from '@scp/ui-shared/components/badges';
import { Icon } from '@scp/ui-shared/theme/icons';
import { ACTIVE_ROUTE_CLASS, E2E_MENU_ITEM_SUFFIX, PROPS_TO_OMIT } from './constants';
import { activeStyleBase, iconBase, itemBase, itemIconBase } from './baseStyles';
var ItemIcon = styled(Icon)(_templateObject(), itemIconBase);
var activeStyle = css(_templateObject2(), activeStyleBase, ItemIcon, iconBase);
var Item = styled(LinkOrButton).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !PROPS_TO_OMIT.includes(prop);
  }
})(_templateObject3(), itemBase, ACTIVE_ROUTE_CLASS, activeStyle, function (props) {
  return props.active && activeStyle;
});
var ItemWithRipple = withRippleEffect(Item);
/**
 * A single link/button menu item,
 * adds required role, aria attributes and styling.
 *
 * Extends LinkOrButton - you can make it work like button, link or `React Router` element.
 * Mostly should be used within `<Menu />`.
 */

export var MenuItem = function MenuItem(_a) {
  var iconName = _a.iconName,
      activeIconName = _a.activeIconName,
      children = _a.children,
      nonFocusable = _a.nonFocusable,
      darkBackground = _a.darkBackground,
      tabIndex = _a.tabIndex,
      dataE2e = _a.dataE2e,
      _a$useNavLink = _a.useNavLink,
      useNavLink = _a$useNavLink === void 0 ? true : _a$useNavLink,
      badgeCount = _a.badgeCount,
      badgeTitle = _a.badgeTitle,
      roundedStyle = _a.roundedStyle,
      otherProps = __rest(_a, ["iconName", "activeIconName", "children", "nonFocusable", "darkBackground", "tabIndex", "dataE2e", "useNavLink", "badgeCount", "badgeTitle", "roundedStyle"]);

  return React.createElement(ItemWithRipple, Object.assign({}, otherProps, {
    nonFocusable: nonFocusable,
    darkBackground: darkBackground,
    // Menu items are navigated using keys (up/down), if it's enabled on `<Menu />`
    tabIndex: nonFocusable ? -1 : tabIndex,
    // if it's NavLink (see LinkOrButton), then it can resolve active state by itself
    activeClassName: ACTIVE_ROUTE_CLASS,
    useNavLink: useNavLink,
    rippleColor: darkBackground ? color.rippleOnDark : color.ripple,
    dataE2e: getE2eLabel(children, E2E_MENU_ITEM_SUFFIX, dataE2e),
    roundedStyle: roundedStyle
  }), React.createElement(IconWithBadge, {
    count: badgeCount,
    badgeTitle: badgeTitle
  }, !!iconName && React.createElement(ItemIcon, {
    name: iconName,
    size: 24,
    "$roundedStyle": roundedStyle
  }), !!(iconName && activeIconName) && React.createElement(ItemIcon, {
    name: activeIconName,
    size: 24,
    "$roundedStyle": roundedStyle
  }), children));
};